import { consume } from '@lit/context';
import { t } from 'i18next';
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Ref, createRef, ref } from 'lit/directives/ref.js';

import { iconEnvelope } from '@/components/icons';
import { GlobalComponentType, global } from '@/context';
import { baseStyles } from '@/styles';

import { FgQuantityStockNotificationDialog } from '@/components/configurator/step/wholesale/quantity/fg-quantity-stock-notification-dialog';

@customElement('fg-quantity-stock-notification-link')
export class FgQuantityStockNotificationLink extends LitElement {
  fgStockNotificationDialogRef: Ref<FgQuantityStockNotificationDialog> =
    createRef();

  @property({ type: String })
  variantName = '';

  @property({ type: String })
  variantCode = '';

  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  openStockNotificationDialog() {
    this.fgStockNotificationDialogRef.value?.openDialog();
  }

  render() {
    return html`
      <div class="notify-stock-link" @click=${this.openStockNotificationDialog}>
        ${iconEnvelope}${t('actions.notifyMe')}
      </div>
      <fg-quantity-stock-notification-dialog
        ${ref(this.fgStockNotificationDialogRef)}
        part=${this.globalContext.layout}
        .variantName=${this.variantName}
        .variantCode=${this.variantCode}
      ></fg-quantity-stock-notification-dialog>
    `;
  }

  static styles = [
    baseStyles,
    css`
      .notify-stock-link {
        display: flex;
        align-items: baseline;
        gap: 4px;
        margin-right: 15px;
        cursor: pointer;
        color: var(--fg-secondary, var(--fg-fallback-secondary));
        font-weight: 700;
      }

      .notify-stock-link:hover {
        text-decoration: underline;
      }

      .notify-stock-link svg {
        flex-shrink: 0;
      }
    `,
  ];
}
